import React, {useState, useEffect} from 'react'
import {Helmet, HelmetProvider} from 'react-helmet-async'
import {confirmAlert} from 'react-confirm-alert'
import {useForm} from 'react-hook-form'
import useBrandsHook from '../../../api/brands'
import {ErrorBoundary} from "react-error-boundary";
import {useNavigate} from 'react-router-dom';
import { ViewBrands } from '../../../components/admin/brands/ViewBrands';
import { FormBrands } from '../../../components/admin/brands/FormBrands';
// import useMachinesHook from '../../../api/machines';
import {checkImageFiles} from '../../../utils/imageTools';
import {useTranslation} from "react-i18next";

import {
    Spinner,
    Pagination,
    Message,
    Confirm,
} from '../../../components'
import {Button} from "@mui/material";

const Brands = () => {
    const [page, setPage] = useState(1)
    const [id, setId] = useState(null)
    const [edit, setEdit] = useState(false)
    const [q, setQ] = useState('')

    const {getBrands, postBrand, updateBrand, deleteBrand} = useBrandsHook({
        page,
        q,
    })

    // const {getMachines} = useMachinesHook({
    //     limit: 100000,
    //     page: 1,
    // })

    // const {data: dataMachines} = getMachines

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: {errors},
    } = useForm({
        defaultValues: {
        },
    })

    const {
        data,
        isLoading,
        isError,
        error,
        refetch
    } = getBrands

    const {
        // data: responseUpdate,
        isLoading: isLoadingUpdate,
        isError: isErrorUpdate,
        error: errorUpdate,
        isSuccess: isSuccessUpdate,
        mutateAsync: mutateAsyncUpdate,
    } = updateBrand

    const {
        // data: responseDelete,
        isLoading: isLoadingDelete,
        isError: isErrorDelete,
        error: errorDelete,
        isSuccess: isSuccessDelete,
        mutateAsync: mutateAsyncDelete,
    } = deleteBrand

    const {
        // data: responsePost,
        isLoading: isLoadingPost,
        isError: isErrorPost,
        error: errorPost,
        isSuccess: isSuccessPost,
        mutateAsync: mutateAsyncPost,
    } = postBrand

    const formCleanHandler = (force = false) => {
        if (force || isSuccessPost || isSuccessUpdate) {
            console.log('clean handler true');
            setEdit(false);
            reset();
            setFileInputs([]); // Also reset the file inputs state
            setImageThumbnails([]); // Also reset the image thumbnails
        }
    }


    const [imageThumbnails, setImageThumbnails] = useState([]);
    const [imagesPath, setImagesPath] = useState({});



    useEffect(() => {
        if (isSuccessPost || isSuccessUpdate) formCleanHandler();
    }, [isSuccessPost, isSuccessUpdate])

    useEffect(() => {
        refetch()
    }, [page])

    useEffect(() => {
        if (!q) refetch()
    }, [q])

    useEffect(() => {
        if (!q) refetch()
    }, [q])


    const searchHandler = (e) => {
        e.preventDefault()
        refetch()
        setPage(1)
    }

    const deleteHandler = (id) => {
        confirmAlert(Confirm(() => mutateAsyncDelete(id)))
    }
    const navigate = useNavigate();

    const [fileInputs, setFileInputs] = useState([]);


    const submitHandler = async (itemData) => {
        try {
            console.log('submitHandler');

            console.log(fileInputs);

            if (edit) {

                const allImages = checkImageFiles(fileInputs);
                await mutateAsyncUpdate({
                    _id: id,
                    brand_id: itemData.brand_id,
                    brand_name: itemData.brand_name,
                    // machine: itemData.machine,
                    brandItems: itemData.brandItems,
                    images: allImages,
                });
                console.log('RESPONSE UPDATE')
            } else {

                // Check and prepare images
                const preparedImages = checkImageFiles(fileInputs);

                const payload = {
                    ...itemData,
                    images: preparedImages,
                };

                console.log('RESPONSE POST')
                await mutateAsyncPost(payload);
            }

            // Request succeeded
            if (edit) {
                console.log('SUCCESSFULL EDIT');
            } else {
                console.log('SUCCESSFULL NEW');
            }
        } catch (error) {
            // Request failed
            console.error(error);
            if (edit) {
                console.log('FAILED EDIT POST')

            } else {
                console.log('FAILED NEW POST')
            }
            if (error.response && error.response.status === 500) {
                console.log('FAILED POST 500')
            }
        }
    };

    const editHandler = (brand) => {
        console.log('editHandler');
        console.log(brand);
        setId(brand._id)
        setEdit(true);
        setValue('brand_id', brand.brand_id);
        // setValue('machine', brand.machine);
        setValue('brand_name', brand.brand_name);

        // setValue('brandItems', brand.brandItems);
        console.log('images');

        console.log(brand.images);
        setImageThumbnails(brand.images)
        setImagesPath(data.images_path);
        setValue('images', brand.images);

    }

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Brands</title>
                    <meta property='og:title' content='Brands' key='title'/>
                </Helmet>
            </HelmetProvider>
            <ErrorBoundary
                FallbackComponent={() => (
                    <ErrorFallback goBack={() => navigate(-1)} error={isSuccessPost}/>
                )}
                onError={console.error}
            >
                {isErrorPost && <Message variant='danger'>{errorPost}</Message>}
                {isErrorUpdate && <Message variant='danger'>{errorUpdate}</Message>}

                {isSuccessDelete && (
                    <Message variant='success'>Brand has been deleted successfully.</Message>
                )}
                {isErrorDelete && <Message variant='danger'>{errorDelete}</Message>}
                {isSuccessUpdate && (
                    <Message variant='success'>Brand has been updated successfully.</Message>
                )}
                {isSuccessPost && (
                    <Message variant='success'>Brand has been Created successfully.</Message>
                )}


                <FormBrands
                    edit={edit}
                    formCleanHandler={formCleanHandler}
                    isLoading={isLoading}
                    isError={isError}
                    isErrorUpdate={isErrorUpdate}
                    errors={errors}
                    isLoadingUpdate={isLoadingUpdate}
                    isLoadingPost={isLoadingPost}
                    register={register}
                    handleSubmit={handleSubmit}
                    submitHandler={submitHandler}
                    watch={watch}
                    error={error}
                    setValue={setValue}
                    imageThumbnails={imageThumbnails}
                    fileInputs={fileInputs}
                    setFileInputs={setFileInputs}
                    // dataMachines={dataMachines}
                    images_path={imagesPath}
                    useTranslation={useTranslation}

                />

                <div className='ms-auto text-end'>
                    <Pagination data={data} setPage={setPage}/>
                </div>

                {isLoading ? (
                    <Spinner/>
                ) : isError ? (
                    <Message variant='danger'>{error}</Message>
                ) : (
                    <ViewBrands
                        data={data}
                        editHandler={editHandler}
                        deleteHandler={deleteHandler}
                        isLoadingDelete={isLoadingDelete}
                        setQ={setQ}
                        q={q}
                        formCleanHandler={formCleanHandler}
                        searchHandler={searchHandler}
                        setEdit={setEdit}
                        reset={reset}
                        useTranslation={useTranslation}
                        // images_path={imagesPath}
                    />
                )}
            </ErrorBoundary>

        </>
    )
}

function ErrorFallback({error, goBack}) {
    const errorMessage = error && error.message ? error.message : "Unknown error";

    return (
        <div>
            <div className="user-error-message-block">
                <p>Something went wrong 😭</p>
                <span>Error: {errorMessage}</span>
                <Button onClick={goBack}>Go Back</Button>
            </div>
        </div>
    );
}

export default Brands
